import type { QueryKey } from '@tanstack/react-query';

export const EXPENSES_PHOENIX_MAIN_KEY: QueryKey = ['expenses-phoenix'];

export const EXPENSES_PHOENIX_KEY = (params?: object): QueryKey =>
  params ? [...EXPENSES_PHOENIX_MAIN_KEY, params] : EXPENSES_PHOENIX_MAIN_KEY;
